<template>
  <v-dialog v-model="isActive" persistent max-width="300px">
    <v-card>
      <v-card-title class="justify-center">
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text class="text-center">
        <div v-for="text in texts" :key="text">{{ text }}</div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-col>
          <v-row justify="center">
            <v-btn class="font-weight-bold" color="primary" large @click="agree">OK</v-btn>
          </v-row>
          <v-row class="mt-5" justify="center">
            <v-btn v-show="showCancel" color="cancel" large text @click="cancel"><span class="text-caption">キャンセル</span></v-btn>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    isActive  : false,
    showCancel: false,
    title     : null,
    texts     : null,
    resolve   : null,
    reject    : null,
  }),
  methods: {
    open(title = '', texts = [], showCancel = false) {
      this.isActive   = true;
      this.showCancel = showCancel;
      this.title      = title;
      this.texts      = texts;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject  = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.isActive = false;
    },
    cancel() {
      this.resolve(false);
      this.isActive = false;
    },
  },
};
</script>

<style></style>
